import React, {useState, useEffect} from 'react';
import {Row, Col, Input, Button} from 'reactstrap';
import {Form, Field} from 'react-final-form';
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import formValidation from "@/shared/validation/program-add";
import axios from 'axios';
import { fetchRoles } from "@/shared/apiHelper";
import { getOrganization, getAuthUser } from '@/containers/App/auth';
import { getSetProgramTree } from "@/services/program/getProgramTree";
import {useDispatch, flashSuccess, flashError } from "@/shared/components/flash"

const AddProgramForm = ({program, organization, user, toggle }) => {
  const [roles, setRoles] = useState(null) //to be passed to assign model

  const dispatch = useDispatch();

  const authOrg = getOrganization();
  
  useEffect(() => {
    if(program?.id && roles === null)
    {
      fetchRoles(program.organization_id, program.id)
      .then(data => {
        setRoles(data);
      })
    }
  })

  const hasValidValues = values => {
    if ((values?.name && values.name.trim() !== "") && values.type) return true;
    return false;
  }

  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmitAddProgram = values => {
    const organization_id =  authOrg?.id
    values = {
      ...values,
      ...{
        setup_fee: 0,
        is_pay_in_advance: 1,
        invoice_for_awards: 0,
        is_add_default_merchants: 1,
        parent_id: program.id,
        factor_valuation: 40,
      }
    }

    setLoading(true)
    axios.post(`/organization/${organization_id}/program`, values)
      .then((res) => {
        if (res.status === 200) {
          assignManagerToProgram(res?.data?.program);
          refreshProgramList(organization_id, res?.data?.program?.parent_id);
        }
      })
      .catch(error => {
        setErrors(error.response.data);
        setLoading(false)
      })
  }
  const refreshProgramList = (orgId, parentId) =>{
    getSetProgramTree(true, orgId, parentId).then(() => {
      window.location.reload();
    });
  }
  const assignManagerToProgram= (program) =>{
    const authOrg = getOrganization();
    const userProgram = getAuthUser();
    let data = {};
    data.is_organization_admin = false
    const managerRole = roles.find(role => role.name === 'Manager');
    data.roles = [managerRole?.id];
    axios.patch(`/organization/${authOrg.id}/program/${program.id}/user/${userProgram.id}/assignRole`, data)
    .then((res) => {
      if (res.status == 200) {
        setLoading(true)
        flashSuccess(dispatch, "Program Created Successfully!")
        toggle()
      }
    })
    .catch(error => {
      setLoading(false)
      flashError(dispatch, error.response.data)
    })
  }

  if (!organization) return 'Loading...'

  return (
    <Form
      onSubmit={onSubmitAddProgram}
      validate={(values) => formValidation.validateForm(values)}
      initialValues={{
        name:  program ? program.name + ' copy' : '',
        setup_fee: 0,
        is_pay_in_advance: true,
        invoice_for_awards: false,
        is_add_default_merchants: false,
        is_demo: false,
      }}
    >
      {({handleSubmit, form, submitting, pristine, values}) => (
        <form className="form" onSubmit={handleSubmit}>
          <div className="manager-program-modal__form-head">
            <h4 className="manager-program-modal__form-title">New Subprogram</h4>
            <p className="manager-program-modal__form-copy">
              Create a child program with its base type and activation mode.
            </p>
          </div>
          {errors &&
            <div className="alert alert-danger fade show w100" role="alert">
              <div className="alert__content">
                <p>{errors.message}</p>
                <ul>
                  {
                    Object.keys(errors.errors).map(function (k) {
                      return <li key={k}>{errors.errors[k]}</li>
                    })
                  }
                </ul>
              </div>
            </div>
          }

          <Field name="name" className="mb-4">
            {({input, meta}) => (
              <div className="form__form-group">
                <span className="form__form-group-label">Program name</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                    <Input type="text" {...input} placeholder="Program name"/>
                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                  </div>
                </div>
              </div>
            )}
          </Field>

          <div className="form__form-group label-mb-0 mt-2 mb-2">
            <span className="form__form-group-label">Program Type</span>
            <Row className='w100'>
              <Col md="6" lg="6" xl="6">
                <Field
                  name="type"
                  component={renderRadioButtonField}
                  label="Employee"
                  radioValue="Employee"
                />
              </Col>
              <Col md="6" lg="6" xl="6" className='hide-error'>
                <Field
                  name="type"
                  component={renderRadioButtonField}
                  label="Customer"
                  radioValue="Resident"
                />
              </Col>
            </Row>
          </div>
          
          <div className="manager-program-modal__footer-actions">
            <Button
              type="submit"
              className="btn btn-primary account__btn account__btn--small"
              disabled={loading}
            >
              Create Program
            </Button>
          </div>
        </form>
      )}
    </Form>
  )
}

export default AddProgramForm;
